import { ChatEvaluationTestSetSample } from "@/API";
import { Button, Group, Modal, Textarea } from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { PropsWithChildren, useEffect } from "react";

export function EditTestSetSampleButton(props: { initValue?: ChatEvaluationTestSetSample, onSubmit?: (value: ChatEvaluationTestSetSample) => void } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);

    const form = useForm<ChatEvaluationTestSetSample>({
        initialValues: props.initValue,
        validate: {
            userInput: isNotEmpty("必填"),
            reference: isNotEmpty("必填"),
        },
    });

    useEffect(() => {
        if (opened) form.setValues(props.initValue ?? {})
    }, [opened])

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="測試資料">
            <form onSubmit={form.onSubmit((values) => {
                props.onSubmit?.(values)
                close()
            })}>
                <Textarea
                    withAsterisk
                    autosize
                    label="使用者輸入"
                    {...form.getInputProps('userInput')}
                />
                <Textarea
                    withAsterisk
                    autosize
                    label="標準回應"
                    {...form.getInputProps('reference')}
                />
                <Group justify="flex-end" mt="md">
                    <Button type="submit">確認</Button>
                </Group>
            </form>
        </Modal>
    </>
}
